import {
    attachmentPolicyOf,
    policyEnablesAttachments,
    policyRequiresBeforeActivation,
} from "../../../../Resources/Scripts/_Shared/attachmentPolicy";

export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

const salesOrderProduct = (bookingFlowContext) =>
    bookingFlowContext?.availableSteps?.onlineBooking?.formData?.productSelection?.item;

export const isSalesOrderAttachmentsEnabled = (bookingFlowContext) => {
    const product = salesOrderProduct(bookingFlowContext);
    const policy = attachmentPolicyOf(product);
    return policy
        ? policyEnablesAttachments(policy)
        : product?.EnableSalesOrderAttachments === true;
};

// Guarded by the enable flag: requiring an attachment on a PMC that skips the upload step would dead-end the order.
export const isSalesOrderAttachmentRequired = (bookingFlowContext) => {
    if (!isSalesOrderAttachmentsEnabled(bookingFlowContext)) return false;
    const product = salesOrderProduct(bookingFlowContext);
    const policy = attachmentPolicyOf(product);
    // Direct purchase treats both MANDATORY policies alike, the waiting list is what distinguishes them.
    return policy
        ? policyRequiresBeforeActivation(policy)
        : product?.RequireSalesOrderAttachments === true;
};

// Keyed on the linked attachment uid, not the File object, which is lost when the flow rehydrates from sessionStorage.
export const hasSalesOrderAttachment = (bookingFlowContext) =>
    !!bookingFlowContext?.availableSteps?.documentUpload?.fileMeta?.uid;

// A product can list several promotions (automatic and featured code ones), so match the one the quote applied.
export const appliedPromotionConfig = (bookingFlowContext, appliedPromotion) =>
    salesOrderProduct(bookingFlowContext)?.Promotions?.find(
        ({ Uid }) => !!Uid && Uid === appliedPromotion?.Uid,
    ) ?? null;

// The "regular price for N months" summary is built for months free (100 %) and half price (50 %) over a period.
export const isMonthsFreeOrHalfPricePromotion = (appliedPromotion, promotionConfig) =>
    [100, 50].includes(appliedPromotion?.Percent) &&
    promotionConfig?.StartAfter != null &&
    promotionConfig?.Duration != null;

export const base64ToFile = (base64String, fileName, mimeType) => {
    const byteString = atob(base64String.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new File([ab], fileName, { type: mimeType });
};
